export default __webpack_public_path__ + "static/media/Iconmyqueries.09929ca6.png";